import { render, staticRenderFns } from "./SortBox.vue?vue&type=template&id=72ba6603&scoped=true"
import script from "./SortBox.vue?vue&type=script&lang=ts"
export * from "./SortBox.vue?vue&type=script&lang=ts"
import style0 from "./SortBox.vue?vue&type=style&index=0&id=72ba6603&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ba6603",
  null
  
)

export default component.exports